<template>

    <div class="contact-banner-bg p-5 h-[400px]" :style="imageUrl('/static/img/contact/thanks.jpg')">

    </div>
    <div class="thanks-text">
        <p>{{ gettext("Merci pour votre intérêt pour Octolo.tech.") }}</p>
        <p>{{ gettext("Nous avons bien reçu votre demande et nous allons la traiter le plus rapidement possible.") }} </p>
        <p>{{ gettext("De manière générale nos équipes reviennent vers vous en moins de 24h.") }} </p>
        <p>{{ gettext("Une urgence ? N’hésitez pas à contacter directement nos équipes sur le tchat disponible en bas à droite sur Octolo.tech.") }} </p>
        <p>{{ gettext("Et en attendant, n’hésitez pas à faire un tour sur notre blog :") }} </p>

        <a href="https://blog.octolo.tech">
            <octolo-buttonv2 class="primary large m-[5px]">
                <span class="i18n"><span class="i18n-text">{{ gettext("Accéder au blog") }}</span></span>
            </octolo-buttonv2>
        </a>

        <p>{{ gettext("Merci pour votre patience et à très vite !") }}</p>
    </div>
</template>

<style lang="scss">
@import "@/assets/octolo.scss";
.thanks-text {
    padding: 50px;
    text-align: center;
    font-size: 20px;
    line-height: 1.5;
    font-weight: 300;
    color: #000;

    * a {
        color: white;
        text-decoration: none
    }
}
</style>
